import { getTokenFromLocalStorage } from 'core/services/axiosInterceptors';

/**
 * Headers expected by the admin service (REACT_APP_ADMIN_BASE_URL).
 * The admin host does not use the primary API's `Authorization: Bearer` / `X-Tenant` scheme.
 * @param extra - Additional headers merged last (override defaults).
 */
export function getAdminAuthHeaders(extra?: Record<string, string>): Record<string, string> {
	const token = getTokenFromLocalStorage('token_key');
	const tenantId = localStorage.getItem('BYOD-organizationId');
	const userId = localStorage.getItem('userId');
	return {
		Accept: 'application/json',
		...(tenantId && { 'X-Tenant-Id': tenantId }),
		...(userId && { 'X-User-Id': userId }),
		...(token && { 'X-Authorization': token }),
		...extra,
	};
}
